<lcs-loading-overlay
   class="queue-history-register-page-loading-overlay"
   [show]="
      isAccountWide &&
      isQueueMembersTabIndex(selectedAccountWideTabIndex) &&
      (queueMembersCallState | lcsCallState : 'loading')
   "
>
   <div class="queue-history-register-layout" [class.account-wide]="isAccountWide">
      @if (isAccountWide) {
      <div class="queue-history-register-global-filter-bar">
         <ndt-queue-history-register-queue-filter
            [isQueueFilterSortable]="true"
            [queueExtensions]="queueExtensions"
            [selectedQueueExtensionIds]="selectedQueueExtensionIds"
            (queueExtensionIdsChange)="onQueueExtensionIdsChange($event)"
         ></ndt-queue-history-register-queue-filter>
      </div>
      <mat-tab-group
         class="detail-tab-group queue-history-register-tab-group"
         [selectedIndex]="selectedAccountWideTabIndex"
         ndt-tab-router
         [loadSuccess$]="loadSuccess$"
         [preserveContent]="true"
         (selectedIndexChange)="onSelectedAccountWideTabIndexChange($event)"
         (animationDone)="onAccountWideTabAnimationDone()"
      >
         @if (showQueueCallsTab) {
         <mat-tab [label]="'Queue Calls'">
            <ng-template matTabContent>
               <div class="mat-tab-indented">
                  <div class="queue-members-tab-overlay-body">
                     <ndt-queue-history-register-queue-members-view
                        [displayMode]="'queue-calls'"
                        [isActive]="selectedAccountWideTabIndex === queueCallsTabIndex"
                        [gridRefreshVersion]="queueMembersGridRefreshVersion"
                        [queueExtensions]="queueExtensions"
                        [selectedQueueExtensionIds]="selectedQueueExtensionIds"
                        [loggedInQueueGroups]="loggedInQueueGroups"
                        [queueCallGroups]="queueCallGroups"
                        [wrapSwimlanes]="wrapQueueSwimlanes"
                        (wrapSwimlanesChange)="onWrapSwimlanesChange($event)"
                        [hangupActiveCallsPrivileges]="hangupActiveCallsPrivileges$ | async"
                        (onOpenCallDetails)="onOpenCallDetails($event)"
                     ></ndt-queue-history-register-queue-members-view>
                  </div>
               </div>
            </ng-template>
         </mat-tab>
         }

         <mat-tab [label]="'Active Calls'">
            <ndt-queue-history-register-view
               [callState]="callState$ | async"
               [dataSource]="dataSource$ | async"
               [isLoading]="isLoading$ | async"
               [hasNextPage]="hasNextPage$ | async"
               [pagingCallState]="pagingCallState$ | async"
               [hangupActiveCallsPrivileges]="hangupActiveCallsPrivileges$ | async"
               [totalCount]="totalCount$ | async"
               [name]="entityName"
               [columns]="columns"
               [hideHeader]="true"
               [showAccountFilters]="true"
               [showQueueColumn]="true"
               [queueExtensions]="queueExtensions"
               (onEmptyExitRoute)="onEmptyExitRoute($event)"
               (onOpenCallDetails)="onOpenCallDetails($event)"
               (loadMore)="onLoadMore()"
               (quickFilterChange)="onQuickFilterChange($event)"
               (onClearCall)="onClearCall($event)"
               [orderingOptions]="orderingOptions$ | async"
               (orderingOptionsChange)="onOrderingOptionsChange($event)"
               [isSystemUser]="isSystemUser$ | async"
            ></ndt-queue-history-register-view>
         </mat-tab>

         @if (showQueueStatusTab) {
         <mat-tab [label]="'Queue Agents'">
            <ng-template matTabContent>
               <div class="mat-tab-indented">
                  <div class="queue-members-tab-overlay-body">
                     <ndt-queue-history-register-queue-members-view
                        [displayMode]="'queues'"
                        [isActive]="selectedAccountWideTabIndex === queueStatusTabIndex"
                        [gridRefreshVersion]="queueMembersGridRefreshVersion"
                        [queueExtensions]="queueExtensions"
                        [selectedQueueExtensionIds]="selectedQueueExtensionIds"
                        [loggedInQueueGroups]="loggedInQueueGroups"
                        [queueCallGroups]="queueCallGroups"
                        [wrapSwimlanes]="wrapQueueSwimlanes"
                        (wrapSwimlanesChange)="onWrapSwimlanesChange($event)"
                        (onOpenCallDetails)="onOpenCallDetails($event)"
                     ></ndt-queue-history-register-queue-members-view>
                  </div>
               </div>
            </ng-template>
         </mat-tab>
         } @if (showAgentStatusTab) {
         <mat-tab [label]="'Agent Status'">
            <ng-template matTabContent>
               <div class="mat-tab-indented">
                  <div class="queue-members-tab-overlay-body">
                     <ndt-queue-history-register-queue-members-view
                        [displayMode]="'agents'"
                        [groupMembersByQueue]="groupMembersByQueue"
                        [isActive]="selectedAccountWideTabIndex === agentStatusTabIndex"
                        [gridRefreshVersion]="queueMembersGridRefreshVersion"
                        [queueExtensions]="queueExtensions"
                        [selectedQueueExtensionIds]="selectedQueueExtensionIds"
                        [loggedInQueueMembers]="loggedInQueueMembers"
                        [loggedInQueueGroups]="loggedInQueueGroups"
                        (groupMembersByQueueChange)="onGroupMembersByQueueChange($event)"
                     ></ndt-queue-history-register-queue-members-view>
                  </div>
               </div>
            </ng-template>
         </mat-tab>
         }
      </mat-tab-group>
      } @else {
      <ndt-queue-history-register-view
         [callState]="callState$ | async"
         [dataSource]="dataSource$ | async"
         [isLoading]="isLoading$ | async"
         [hasNextPage]="hasNextPage$ | async"
         [pagingCallState]="pagingCallState$ | async"
         [hangupActiveCallsPrivileges]="hangupActiveCallsPrivileges$ | async"
         [totalCount]="totalCount$ | async"
         [name]="entityName"
         [columns]="columns"
         [showAccountFilters]="false"
         [showQueueColumn]="false"
         [queueExtensions]="queueExtensions"
         (onEmptyExitRoute)="onEmptyExitRoute($event)"
         (onOpenCallDetails)="onOpenCallDetails($event)"
         (loadMore)="onLoadMore()"
         (quickFilterChange)="onQuickFilterChange($event)"
         (onClearCall)="onClearCall($event)"
         [orderingOptions]="orderingOptions$ | async"
         (orderingOptionsChange)="onOrderingOptionsChange($event)"
         [isSystemUser]="isSystemUser$ | async"
      ></ndt-queue-history-register-view>
      }
   </div>
</lcs-loading-overlay>
